<template>
  <v-dialog v-model="dialog" persistent max-width="600">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined color="error" class="mr-3">
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <h2>
              Confirma que deseja deletar a
              {{ isAT || isGov ? "atividades" : "tarefas" }}?
            </h2>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityTaskAPI } from "@/modules/city/API/CityTaskAPI";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalDeleteTask",
  props: {
    payload: { type: Object, required: true },
  },
  data() {
    return {
      dialog: false,
    };
  },
  computed: {
    ...mapGetters(["user", "isAT", "isGov"]),
  },
  mounted() {},
  methods: {
    ...mapActions(["setLoading"]),

    onConfirm() {
      this.setLoading(true);

      cityTaskAPI
        .delete(this.payload.municipioTarefaId)
        .then((resp) => {
          this.dialog = false;
          this.$emit("on-save");
          this.setLoading(false);
        })
        .catch((e) => {
          this.setLoading(true);
        });
    },
  },
};
</script>
